module.exports = __webpack_public_path__ + "static/img/icon_hitem6.60d4bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem6.png
// module id = NdBH
// module chunks = 21